import cookie from 'cookie';
import queryString from 'query-string';
import mapKeyValues, { transforms as t } from 'lib/mapKeyValues';
import getBreakpointSize from 'lib/getBreakpointSize';
import normalizePageType from 'lib/normalizePageType';

export const getCurrentBreakpoint = () => {
  const breakpointMap = window.DatMCP._breakpoints;
  return breakpointMap ? getBreakpointSize(window, breakpointMap) : null;
};

export const getDeliveryChannel = () =>
  (['small', 'medium'].indexOf(getCurrentBreakpoint()) >= 0 ? 'mobile' : 'web');

/**
 * List of keys that can be carried over from mdManager
 * @type {Array}
 */
export const validKeys = [
  { key: 'type', transform: [t.toLowerCase, t.sanitizeValueIncDash] },
  { key: 'pagetype', transform: [normalizePageType, t.toLowerCase, t.sanitizeValueIncDash] },
  'uniqueid',
  { key: 'uniqueid', mappedKey: 'page_uniqueid', transform: [] },
  'topic',
  'keyterm',
  'adkey1',
  'talentName',
  'showName',
  'keyword',
  'contenttag1',
  'contenttag2',
  { key: 'categorydspname', transform: [t.toLowerCase] },
  { key: 'categorydspname', mappedKey: 'category' },
  'photocount',
  'vgncontent',
  'show_abbr',
  'sniads_regression_test',
  {
		key: 'ingredients',
		mappedKey: 'ing',
		transform: [t.split(','), t.mapTransform(t.toLowerCase)],
	},
  'scripps160',
  'scripps250',
  'scripps600',
  'scripps728',
  'scripps320',
  'scripps250btf',
  'scripps250m',
  'cs_debug',
  { key: 'sponsorship', mappedKey: 'topic' },
  'subsection',
  'subsection1',
  'subsection2',
  'subsctn1',
  'subsctn2',
  'source',
  'livingsource',
  'orntn',
  'version',
  'sbi_apoc',
  'sbi_size',
  'sbi_dozer',
  'glist',
  'mcid',
  'aam_fw',
  'main_ing',
  { key: 'site', transform: [t.toLowerCase, t.sanitizeValueIncDash] },
  // 'page_uniqueid',
  'strnativekey',
  { key: 'classification', transform: [t.split(','), t.mapTransform(t.toLowerCase)] },
  'abkey',
  'kuid',
  'ksg',
  'light_mode',
  // 'delivery_channel',
  { key: 'delivery_channel', transform: [getDeliveryChannel] },
  { key: 'sctndspname', transform: [t.toLowerCase] },
  'targetedterms',
  { key: 'breakpoint', transform: [getCurrentBreakpoint] },
];

export function getCookieValues() {
  const cookies = cookie.parse(window.document.cookie);
  const validCookies = {};

  validCookies.us_privacy = cookies.us_privacy;
  validCookies.usprivacy = cookies.usprivacy;

  if (cookies.aam_fw) {
    validCookies.aam_fw = cookies.aam_fw.split(';').map(i => i.split('=')[1]);
  }

  if (cookies['AMCV_BC501253513148ED0A490D45%40AdobeOrg']) {
    const adobeCookie = ['id', ...cookies['AMCV_BC501253513148ED0A490D45%40AdobeOrg'].split('|')]
      .reduce((prev, current, index, array) =>
        (index % 2 === 0 ? { ...prev, [current]: array[index + 1] } : prev),
      {});

    validCookies.mcid = adobeCookie.MCMID;
  }

	// Add Prism identifier
	validCookies.wmuk = cookies.datid || cookies.WMUKID_STABLE;
	validCookies.ppid = cookies.datid || cookies.WMUKID_STABLE;

  return validCookies;
}

/**
 * Retrieves meta data from mdManager and returns it
 * @return {Object} Meta data from mdManager
 */
export default function foodcomSiteMetaData() {
  try {
    const { mdManager } = window;
    const { search } = window.location;
    /* eslint-disable-next-line camelcase */
    const { ad_topic } = queryString.parse(search);

    const getValueFromMdManager = key => mdManager.getParameterString(key);

    const keyValues = mapKeyValues(validKeys, getValueFromMdManager);
    const cookieValues = getCookieValues();

    /* eslint-disable camelcase */
    if (ad_topic !== undefined) {
      keyValues.topic = ad_topic;
    }
    /* eslint-enable camelcase */

    keyValues.config_channel = 'standard';
    keyValues.layout = 'responsive';

    return { ...keyValues, ...cookieValues };
  } catch (e) {
    throw new Error(e);
  }
}
